export default __webpack_public_path__ + "static/media/bg5.0380b1f1.jpg";